import script from "./article-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./article-edit.vue?vue&type=script&setup=true&lang=js"

import "./article-edit.vue?vue&type=style&index=0&id=74235f19&scoped=true&lang=scss"
import "./article-edit.vue?vue&type=style&index=1&id=74235f19&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74235f19"]])

export default __exports__